export interface ValidationStationTestResponseDto {
  id: number;
  stationId: string;
  isRunning: boolean;
  isSubmitted: boolean;
  startedAt: Date;
  endedAt: Date | null;
  testBy: string | null;
}

export interface ValidationStationTestWithDevicesResponseDto extends ValidationStationTestResponseDto {
  testDevicesScenario: ValidationDeviceResultTestResponseDtoWithDeviceData[];
}

export interface ValidationDeviceResultTestResponseDto {
  id: number;
  deviceId: string;
  status: ValidationDeviceStatus;
  parameter: ValidationDeviceParameter;
  groupPowerSensorId?: string;
  groupFlowSensorId?: string;
  value?: number;
  comment?: string;
  stationTest: {
    id: number;
    stationId: string;
    isRunning: boolean;
    isSubmitted: boolean;
    startedAt: Date;
    endedAt: Date | null;
  };
}

export interface ValidationDeviceResultTestResponseDtoWithDeviceData extends ValidationDeviceResultTestResponseDto {
  flowSensorName?: string;
  powerSensorName?: string;
  compressorName?: string;
  compressorConnectivity?: string;
}

export class GetAllSubmittedTestsResponseDto {
  testId: number;
  startedAt: Date;
  endedAt: Date;
  stationId: string;
  testBy: string;
}

export enum ValidationDeviceParameter {
  LOAD = 'LOAD',
  UNLOAD = 'UNLOAD',
  OFF = 'OFF',
  FLOW = 'FLOW',
}

export enum ValidationDeviceStatus {
  PASS = 'PASS',
  FAILED = 'FAILED',
  NOT_TESTED = 'NOT_TESTED',
  NOT_INCLUDE_SENSOR = 'NOT_INCLUDE_SENSOR',
}

export interface StationTestDto {
  id: number;
  stationId: string;
  isRunning: boolean;
  isSubmitted: boolean;
  startedAt: string;
  endedAt: string | null;
  testDevicesScenario: TestDeviceScenario[];
  testBy: string | null;
}

export interface TestDeviceScenario {
  groupFlowSensorId: string | null;
  flowSensorName: string | null;
  compressors: Compressor[];
  FLOW?: TestParameter;
}

export interface Compressor {
  deviceId: string;
  compressorName: string;
  compressorConnectivity: string;
  groupPowerSensorId: string | null;
  groupFlowSensorId: string | null;
  stationTest: StationTest;
  flowSensorName: string | null;
  powerSensorName: string | null;
  LOAD?: TestParameter;
  UNLOAD?: TestParameter;
  FLOW?: TestParameter;
  elementIndex: number;
  modelDisplayName: string;
  brand: string;
  modelName: string;
}

export interface StationTest {
  id: number;
  startedAt: string | null;
  endedAt: string | null;
}

export interface TestParameter {
  id: number;
  status: ValidationDeviceStatus;
  value: number;
  comment: string | null;
  realValue: number | null;
  expectValue: number | null;
}

export enum TestState {
  INITIAL = 'INITIAL',
  RUNNING = 'RUNNING',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  TEST_SUCCESS = 'TEST_SUCCESS',
  SUBMITTED = 'SUBMITTED',
}
export interface UserComment {
  resultId: number;
  comment: string;
}
